/* eslint-disable prefer-template */
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _, { isFunction } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';
import {
  fetchAllAsync,
  selectEmpresasEstrangeiras,
  fetchFilteredAsync,
  fetchByIdAndInsertList,
} from '../../features/empresa-estrangeira/empresaEstrangeiraSlice';

import { getLocalidadeOrDefault } from '../../utils/general/general-utils';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectEmpresaEstrangeiraAutocompleteAutoLoad({
  label,
  name,
  filterPredicate,
  importadorId,
  ...restProps
}) {
  const dispatch = useDispatch();
  const list = useSelector(selectEmpresasEstrangeiras);
  const { values } = useFormState();

  const [filteredEmpresasEstrangeiras, setFilteredEmpresasEstrangeiras] = useState([]);
  const [emptyListMsg, setEmptyListMsg] = useState('');
  const [defaultValue, setDefaultValue] = useState(null);

  useEffect(() => {
    dispatch(fetchAllAsync());
  }, [dispatch]);

  useEffect(() => {
    if (isFunction(filterPredicate)) {
      const filtered = list?.filter(filterPredicate) ?? [];
      setFilteredEmpresasEstrangeiras(filtered);
      setEmptyListMsg(filtered.length ? '' : 'Nenhuma empresa encontrada');
    } else {
      const safeList = list ?? [];
      setFilteredEmpresasEstrangeiras(safeList);
      setEmptyListMsg(safeList.length ? '' : 'Nenhuma empresa encontrada');
    }
  }, [list, filterPredicate]);

  useEffect(() => {
    const selectedId = _.get(values, name);
    if (!selectedId) {
      setDefaultValue(null);
      return;
    }

    const value = list?.find((item) => String(item.id) === String(selectedId));

    if (value) {
      setDefaultValue(value);
      return;
    }

    setDefaultValue(null);
    _.debounce(() => dispatch(fetchByIdAndInsertList(selectedId)), 200)();
  }, [list, values, name, dispatch]);

  const filterOptions = useMemo(
    () =>
      createFilterOptions({
        stringify: (item) =>
          `${item?.id} - ${item?.pessoaJuridica?.nomeResumido || item?.pessoaJuridica?.nome || item?.description || ''}`,
      }),
    []
  );

  const getOptionLabel = (item) => {
    let codOpe;
    if (importadorId) {
      codOpe = item?.relacaoClientes?.find((r) => r?.cliente?.id === importadorId)?.codigoExportadorSiscomex;
    } else {
      codOpe = item?.relacaoClientes?.[0]?.codigoExportadorSiscomex;
    }

    return item?.id
      ? `${item?.id} ${codOpe ? ' - ' + codOpe : ''} - ${
          item?.pessoaJuridica?.nomeResumido || item?.pessoaJuridica?.nome || item?.description || ''
        } - ${getLocalidadeOrDefault(item?.endereco)}`
      : '';
  };

  const searchFilteredEmpresasList = useMemo(
    () =>
      _.debounce((value) => {
        if (!value) {
          dispatch(fetchAllAsync());
          return;
        }

        dispatch(fetchFilteredAsync(value));
      }, 250),
    [dispatch]
  );


  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      onEventActionPaiFunction={searchFilteredEmpresasList}
      options={filteredEmpresasEstrangeiras}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={getOptionLabel}
      emptyListMsg={emptyListMsg}
      placeholder=""
      {...restProps}
    />
  );
}
